import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

export const MainBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const MainText = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '34px',
  lineHeight: '40px',
  textAlign: 'center',
  letterSpacing: '0.05px',
  color: theme.palette.secondary.main,
}));

export const SubText = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '20px',
  lineHeight: '24px',
  textAlign: 'center',
  letterSpacing: '0.05px',
  color: theme.palette.common.tabsTextColor,
}));
